import { render, staticRenderFns } from "./EstimatesOldPageTask.vue?vue&type=template&id=0f7be1d7&"
import script from "./EstimatesOldPageTask.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldPageTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports